import { render } from "./TermsOfServices.vue?vue&type=template&id=1a2314d8&scoped=true"
import script from "./TermsOfServices.vue?vue&type=script&lang=js"
export * from "./TermsOfServices.vue?vue&type=script&lang=js"

import "./TermsOfServices.vue?vue&type=style&index=0&id=1a2314d8&scoped=true&lang=css"

import exportComponent from "/builds/appmart-development-team/appmart-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a2314d8"]])

export default __exports__